export const NAV = {
  wrapper: "nav-wrapper",
  logo: "nav-logo",
  linkAbout: "nav-link-about",
  linkWhy: "nav-link-why",
  linkLeadership: "nav-link-leadership",
  linkEvent: "nav-link-event",
  rsvpCta: "nav-rsvp-cta",
};

export const HERO = {
  requestInvite: "hero-cta-request",
  exploreFund: "hero-cta-explore",
};

export const RSVP = {
  section: "rsvp-section",
  firstName: "rsvp-first-name",
  lastName: "rsvp-last-name",
  email: "rsvp-email",
  phone: "rsvp-phone",
  company: "rsvp-company",
  submit: "rsvp-submit",
  successState: "rsvp-success-state",
};

export const ADMIN = {
  passcodeInput: "admin-passcode-input",
  passcodeSubmit: "admin-passcode-submit",
  logoutBtn: "admin-logout",
  exportCsv: "admin-export-csv",
  table: "admin-rsvp-table",
  count: "admin-rsvp-count",
};
